import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiX } from "react-icons/bi";
import { BsExclamationCircleFill } from "react-icons/bs";

interface Props {
  texts: any[];
  isClose?: boolean; // optional prop to control close button visibility. Default is true.
}

const InfoMessageAlert = ({ texts, isClose }: Props) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);

  return (
    <>
      {show && (
        <div className="tw-w-full tw-pl-2 pr-3 py-1 tw-bg-orange-50 tw-rounded-xl tw-justify-between tw-items-center tw-gap-1.5 tw-inline-flex mt-2">
          <div className="tw-w-full tw-flex tw-items-center tw-gap-2">
            <div className="tw-py-0.5 tw-justify-start tw-items-center tw-gap-2.5 tw-flex">
              <BsExclamationCircleFill className="tw-text-[#D97706]" />
            </div>
            <div className="tw-grow tw-shrink tw-basis-0 tw-text-amber-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
              {texts.map((text, index) => (
                <p className="m-0" key={index}>
                  {text}
                </p>
              ))}
            </div>
          </div>
          {isClose && (
            <div className="tw-p-2">
              <BiX
                className="tw-cursor-pointer "
                onClick={() => {
                  setShow(false);
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InfoMessageAlert;
